// extracted by mini-css-extract-plugin
module.exports = {"UserForm":"UserForm_UserForm__Abqfk","UserForm__Item":"UserForm_UserForm__Item__3xeMJ","UserForm__Message":"UserForm_UserForm__Message__3awWa"};